import React, {Component} from "react";
import LayoutHeader from '../Inc/Header';
import AdminNavigation from '../Inc/AdminNavigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Input, Modal, Button, Upload, Tooltip, Tabs, message, AutoComplete, Spin, Row, Col, Dropdown, Icon, Menu, Popconfirm, Form, Select, Radio, DatePicker, Checkbox } from 'antd';
import * as actions from "../../actions/index";
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { history } from '../../container/History';
import Skeleton from 'react-loading-skeleton';
import './RecordRepair.css';
import moment from 'moment';
import InputMask from 'react-input-mask';
import warningAlert from '../Membership/warning-alert.png';
const FormItem = Form.Item;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const { Option } = AutoComplete;


class AddAlumniRecord extends Component {

  constructor(props) {
    super(props)
    this.state = {
      ...props,
      personGUID: '',
      loading: false,
      returnto: 'record-repair',
      prevPath: undefined,
      changedStateID: '',
      eagleUnitId: '',
      isUpdateCurrentOrganization: false,
    }
  }

  componentDidMount = () => {
    let personGUID = this.props.match.params.personGuid;
    let prevPath = localStorage.getItem("prevPath") ? JSON.stringify(localStorage.getItem("prevPath")) : undefined
    if(prevPath){
      this.setState({
        prevPath
      })
    }
    if (this.state.personGUID == '') {
      this.setState({
        personGUID: personGUID
      })
    }
    if (this.props.PersonGuid) {
      this.setState({
        personGUID: this.props.PersonGuid
      })
      personGUID = this.props.PersonGuid
    }
    this.props.actions.getAlumniEagleInfo(personGUID)
    if (this.props.match.params.returnto) {
      this.setState({
        returnto: this.props.match.params.returnto
      })
    }
    
    this.props.actions.getAlumniInfo(personGUID, this.props.isspecialist ? "" : "admin")
    this.props.actions.getAllOrganizationCouncils()
    this.props.actions.getStates()
    // this.props.actions.getEagleInfo()
  }

  rendereagleflag = () => {
    if (this.props.eagleinfo) {
      if (Object.keys(this.props.eagleinfo).length != 0) {
        if (this.props.eagleinfo.eagleBoardReviewDate != "") {
          return <img  className="eagle-logo eagle-logo-img" src='../../eagle-scout.png' />
        }
      }
    }
  }

  handleStateChange = (e) => {
    this.setState({
        changedStateID: e
    })
}

  handleEagleUnitChange = (e) => {
    this.setState({
      eagleUnitId: e
    })
  }

  states = () => {
    if (this.props.allstates) {
        let statesarray = this.props.allstates
        return statesarray.map((k, index) => {
            return (
                <option key={k.id} value={k.id}>{k.short}</option>
            )
        })
    }
}

handelChangeBackToSearch = (data) => {
  this.props.removeEditAlumni(data)
}

cancelActions = () => {
  this.props.form.resetFields()
}

updateCurrentOrganization = (e) => {
  e.preventDefault();
  if(e.target.checked) {
     this.setState({isUpdateCurrentOrganization: true})
  } else {
    this.setState({isUpdateCurrentOrganization: false})
  }
}
getCouncilDetails = (values, neededInfo) => {
  const { currentOrganization, eagleOrganization, eagleCouncilName } = this.props.eagleinfo;
  let currentCouncil = '';
  let eagleCouncil = '';
  if (neededInfo == "councilGuid") {
    if (currentOrganization.name && Array.isArray(this.props.councils) && this.props.councils.length > 0) {
      let getCurrentCouncil = this.props.councils.find(council => council.councilName == currentOrganization.name);
      if (getCurrentCouncil) {
        currentCouncil = getCurrentCouncil.councilGuid
      }
    }
    if (eagleOrganization.name && Array.isArray(this.props.councils) && this.props.councils.length > 0) {
      let getEagleCouncil = this.props.councils.find(council => council.councilName == eagleOrganization.name);
      if (getEagleCouncil) {
        eagleCouncil = getEagleCouncil.councilGuid
      }
    }
  }

  if (neededInfo == "CouncilNumber") {
    if (values.currentCouncil && Array.isArray(this.props.councils) && this.props.councils.length > 0) {
      let getCurrentCouncil = this.props.councils.find(council => council.councilGuid == values.currentCouncil);
      if (getCurrentCouncil) {
        currentCouncil = getCurrentCouncil.councilName.match(/\d+/)[0]
      }
    }
    if (values.eagle_council && Array.isArray(this.props.councils) && this.props.councils.length > 0) {
      let getEagleCouncil = this.props.councils.find(council => council.councilGuid == values.eagle_council);
      if (getEagleCouncil) {
        eagleCouncil = getEagleCouncil.councilName.match(/\d+/)[0]
      }
    }
  }
  return { eagleCouncil, currentCouncil };
}

handleSubmit = (e) => {
  e.preventDefault();
  let eagleId = this.props.eagleinfo.eagleId;
  this.props.form.validateFieldsAndScroll((err, values) => {
    if (!err) {
        console.log(values);
        const { eagleCouncil, currentCouncil } = this.getCouncilDetails(values, 'CouncilNumber');
        values.eagleCouncilNumber = eagleCouncil;
        values.currentCouncilNumber = currentCouncil;
        this.props.actions.AddNewEagleDetailsRepairInfo(values, this.props.profileinfo, this.state.personGUID)
    }
})
}

  rendercouncils = () => {
    if (this.props.councils && this.props.profileinfo) {
      let councilLookup = this.props.councils
      
      return <Row style={{ width: "100%" }}>
        <Col span={24} >
          <span className='small-txt'> Please select your Council Affiliation: </span>
        </Col>
        <Col span={24}>
          <Select
            className='scoutingsselect'
            showSearch
            placeholder="Please select Affilitaions to add"
            optionLabelProp="label"
            style={{ width: "100%" }}
            onChange={this.addCouncils}
            value={null}
          >
            {councilLookup.map((council) => (
              <Option key={council.councilId} label={council.councilName} value={council.councilName}>
                <div>
                  {/* <Avatar
                    src={scoutings.logo}
                    icon='shop'
                    size='small'
                  /> */}
                  <span >{council.councilName}</span>
                </div>
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
    }
  }

  renderEditView = () => {
    if (this.props.updating) {
      return (<Spin indicator={LoadingIcon} className="loading-state" style={{ height: 420 }} tip="Updating Information..." />)
    } else if (this.props.loading) {
      return (<Spin indicator={LoadingIcon} className="loading-state" style={{ height: 420 }} tip="Loading Information..." />)
    } else if (this.props.eagleinfo && !this.props.loading) {
      // if (!this.props.eagleinfo.eagleId) {
      //   return <Modal
      //     style={{ width: '600px' }}
      //     title={false}
      //     footer={false}
      //     visible={true}
      //     maskClosable={false}
      //     centered
      //     onCancel={() => this.handelChangeBackToSearch("false")}
      //   >
      //     <div className="center">
      //       <div>
      //         <img src={warningAlert} width="40px" height="40px" />
      //       </div>
      //       <div className='No-Results-Match-Pro'>
      //         Missing Information
      //       </div>
      //       <div className='Errorpopup' > EagleID Is Not Found. </div>
      //       <Row type='flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
      //         <Col className='xs-center sm-center' xs={9} sm={9} md={7} lg={7} xl={7}>
      //           <div className='step-container margin-top-20' >
      //             <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%", height: '42px' }} onClick={() => this.handelChangeBackToSearch("false")} htmlType='submit'>CLOSE </Button>
      //           </div>
      //         </Col>
      //       </Row>
      //     </div>
      //   </Modal>
      // }
      return this.renderEagleValueForm(this.props.eagleinfo)
    }
    else {
        return (<Spin indicator={LoadingIcon} className="loading-state" tip="Loading Information..." />)
    }
  }

  eagleUnits = () => {
    let eaglePrograms = [{programId: 1,programValue: 'Troop'}, 
      {programId: 2,programValue: 'Pack'},
      {programId: 3,programValue: 'Crew'},
      {programId: 4,programValue: 'Ship'},
      {programId: 5,programValue: 'Post'}
    ];

    eaglePrograms.sort((a, b) => {
      return a.programValue.localeCompare(b.programValue);
    });

    return eaglePrograms.map((k, index) => {
      return (
          <option key={k.programId} value={k.programValue}>{k.programValue}</option>
      )
  })
  }

  allCouncils = () => {
    if (this.props.councils && !this.props.councils_adding) {
      let councilsArray = this.props.councils.sort((a, b) => a.councilName - b.councilName)
      return councilsArray.map((k, index) => {
        return (
          <Select.Option key={k.councilGuid} value={k.councilGuid}>{k.councilName}</Select.Option>
        )
        this.forceUpdate()
      })
    }
  }

  countries = () => {
    if (this.props.countries) {
      let countriesarray = this.props.countries.sort((a, b) => a.name - b.name)
      return countriesarray.map((k, index) => {
          return (
              <option key={index} value={k.short}>{k.name}</option>
          )
      })
  }
}

validateNotFutureDate = (rule, value, callback) => {
    if (!value) return callback();

    const inputDate = moment(value, 'MM/DD/YYYY');
    const today = moment().endOf('day');

    if (inputDate.isAfter(today)) {
        callback('Future dates are not allowed');
    } else {
        callback();
    }
}

isSaveDisabled = () => {
    const { getFieldsError } = this.props.form;
    const errors = getFieldsError(['validatedDate', 'certifiedDate', 'boardOfReviewDate']);
    return Object.values(errors).some(err => err);
}

  renderEagleValueForm = (eagleinfo) => {
    const FormItem = Form.Item;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const GetEagleCountry = (Array.isArray(this.props.countries) && this.props.countries.length > 0) ? this.props.countries.find(country => country.short == eagleinfo.eagleCountryId) : ''

    return (
      <div className='edit-eagle-info'>
          <Form onSubmit={this.handleSubmit} className="alumni-ui eagle-edit-form">
          <Row type='flex' justify='start' align='middle'>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                  <FormItem hasFeedback
                      label="Eagle Program"
                  >
                      {getFieldDecorator('eagleProgram', {
                          initialValue:  eagleinfo && eagleinfo.eagleUnitType ? eagleinfo.eagleUnitType : '' ,
                          rules: [
                              { required: true, message: 'Enter Eagle\'s Program!' },
                          ],
                      })(
                        <Select
                            onChange={this.handleEagleUnitChange}
                            showSearch
                            style={{ width: '100%' }}
                            placeholder="Select a Unit"
                            optionFilterProp="children"
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        >
                            {this.eagleUnits()}
                        </Select>
                      )}
                  </FormItem>
              </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                  <FormItem hasFeedback
                      label="Eagle Unit"
                  >
                      {getFieldDecorator('eagleUnit', {
                          initialValue:  eagleinfo && eagleinfo.eagleUnitType ? eagleinfo.eagleUnitType : '' ,
                          rules: [
                              { required: true, message: 'Enter Eagle\'s Unit!' },
                          ],
                      })(
                        <Select
                            onChange={this.handleEagleUnitChange}
                            showSearch
                            style={{ width: '100%' }}
                            placeholder="Select a Unit"
                            optionFilterProp="children"
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        >
                            {this.eagleUnits()}
                        </Select>
                      )}
                  </FormItem>
              </Col>

              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <FormItem hasFeedback
                    label="Unit City"
                >
                    {getFieldDecorator('unitCity', {
                        initialValue: eagleinfo && eagleinfo.eagleUnitCity ? eagleinfo.eagleUnitCity : '' ,
                        rules: [
                          { required: true, message: 'Enter Unit\'s City Name!' },
                          { pattern: /^[a-zA-Z ]*$/, message: `Please enter valid characters` }
                        ],
                    })(
                        <Input placeholder="Unit City" />
                    )}
                </FormItem>
              </Col>

            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <FormItem hasFeedback
                    label="State"
                >
                    {getFieldDecorator('unitState', {
                        initialValue: eagleinfo && eagleinfo.eagleUnitState ? eagleinfo.eagleUnitState : ''  ,
                        rules: [{ required: true, message: 'Enter Unit\'s State!' }],
                    })(
                        <Select
                            onChange={this.handleStateChange}
                            showSearch
                            style={{ width: '100%' }}
                            placeholder="Select a State"
                            optionFilterProp="children"
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        >
                            {this.states()}
                        </Select>
                    )}
                </FormItem>
            </Col>
                    

            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <FormItem hasFeedback
                    label="Created By"
                >
                    {getFieldDecorator('createdBy', {
                        initialValue: eagleinfo && eagleinfo.eagleCertificateBy ? eagleinfo.eagleCertificateBy : '' ,
                        rules: [
                          { required: true, message: 'Enter Creater\'s Name!' },
                          // { pattern: /^[a-zA-Z ]*$/, message: `Please enter valid characters` }
                        ],
                    })(
                        <Input placeholder="Created By" />
                    )}
                </FormItem>
              </Col>

              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        <FormItem hasFeedback label="Eagle Council">
                            {getFieldDecorator("eagle_council", {
                                rules: [
                                    {
                                        required: true,
                                        message: "Enter Eagle Council!",
                                    },
                                ],
                            })(
                                <Select
                                    showAction={['focus', 'click']}
                                    showSearch
                                    style={{ width: '100%' }}
                                    placeholder="Select Scout's Eagle Council!"
                                    optionFilterProp="children"
                                    onChange={(e) => {
                                        this.setState({
                                            scoutsCountry: e,
                                        })
                                    }}
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {this.allCouncils()}
                                </Select>
                            )}
                        </FormItem>
                    </Col>

                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <FormItem hasFeedback
                label="Eagle Country"
              >
                {getFieldDecorator(`eagleCountry`, {
                  initialValue:  GetEagleCountry ? GetEagleCountry : "US",
                  rules: [{ required: true, message: 'Select Eagle Country!' }],
                })(
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="Select a Country"
                    optionFilterProp="children"
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  >
                    {this.countries()}
                  </Select>
                )}
              </FormItem>
            </Col>

              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        <FormItem hasFeedback label="Current Council">
                            {getFieldDecorator("currentCouncil", {
                                rules: [
                                    {
                                        required: true,
                                        message: "Enter current Council!",
                                    },
                                ],
                            })(
                                <Select
                                    showAction={['focus', 'click']}
                                    showSearch
                                    style={{ width: '100%' }}
                                    placeholder="Select Scout's current Council!"
                                    optionFilterProp="children"
                                    onChange={(e) => {
                                        this.setState({
                                            scoutsCountry: e,
                                        })
                                    }}
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {this.allCouncils()}
                                </Select>
                            )}
                        </FormItem>
                    </Col>

            {/* <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <FormItem hasFeedback
                    label="System Context"
                >
                    {getFieldDecorator('systemContext', {
                        initialValue: eagleinfo && eagleinfo.validatedBy ? eagleinfo.validatedBy : '' ,
                        // rules: [
                        //   { required: true, message: 'Enter System Context!' },
                        // //   { pattern: /^[a-zA-Z ]*$/, message: `Please enter valid characters` }
                        // ],
                    })(
                        <Input />
                    )}
                </FormItem>
              </Col> */}

            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <FormItem hasFeedback
                    label="Validate By"
                >
                    {getFieldDecorator('validatedBy', {
                        initialValue: eagleinfo && eagleinfo.validatedBy ? eagleinfo.validatedBy : '' ,
                        rules: [
                          { required: true, message: 'Enter Validater\'s Name!' },
                          { pattern: /^[a-zA-Z ]*$/, message: `Please enter valid characters` }
                        ],
                    })(
                        <Input placeholder="Validated By" />
                    )}
                </FormItem>
              </Col>

              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <FormItem
                hasFeedback
                // validateStatus={this.state.anyFutureDateField == 'validatedDate' ? "error" : undefined}
                // help={this.state.CustomDateErrMsg ? this.state.CustomDateErrMsg : undefined}
                // onBlur={(e) => this.CheckTheDate(e.target.value, 'validatedDate')}
                label={
                  <span>
                    Verified Date&nbsp;
                  </span>
                }
              >
                {getFieldDecorator('validatedDate', {
                  initialValue: eagleinfo && eagleinfo.validatedDt ? (eagleinfo.validatedDt != '' ? moment(eagleinfo.validatedDt).format('MM/DD/YYYY') : '') : '',
                  rules: [
                    { required: true, message: 'Enter Verified Date' },
                    { validator: this.validateNotFutureDate },
                    {
                      pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                      message: `Please enter correct format MM/DD/YYYY Pattern`
                    }
                  ],
                })(
                  // <Input placeholder="Date Of Birth" />

                  <InputMask
                    mask="99/99/9999"
                    placeholder='MM/DD/YYYY'
                    alwaysShowMask
                    maskChar={null}
                    className="ant-input width-100"
                    render={(ref, props) => (
                      <Input />
                    )}
                  />

                )}
              </FormItem>
            </Col>

            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <FormItem hasFeedback
                    label="Certified By"
                >
                    {getFieldDecorator('certifiedBy', {
                        initialValue: eagleinfo && eagleinfo.certifiedBy ? eagleinfo.certifiedBy : '' ,
                        rules: [
                          { required: true, message: 'Enter certifier\'s Name!' },
                          // { pattern: /^[a-zA-Z ]*$/, message: `Please enter valid characters` }
                        ],
                    })(
                        <Input placeholder="Certified By" />
                    )}
                </FormItem>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                  <FormItem 
                  hasFeedback
                  validateStatus={this.state.IsFutureDate ? "error"  : undefined}
                      label={
                          <span>
                              Certified Date&nbsp;
                          </span>
                      }
                  >
                      {getFieldDecorator('certifiedDate', {
                          initialValue: eagleinfo && eagleinfo.eagleCertificateDate ? (eagleinfo.eagleCertificateDate != '' ? moment(eagleinfo.eagleCertificateDate).format('MM/DD/YYYY') : '') : '',
                          rules: [
                              { required: true, message: 'Enter Certified Date ' },
                              { validator: this.validateNotFutureDate },
                              {
                                  pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                  message: `Please enter correct format MM/DD/YYYY Pattern`
                              }
                          ],
                      })(
                          // <Input placeholder="Date Of Birth" />

                          <InputMask
                              mask="99/99/9999"
                              placeholder='MM/DD/YYYY'
                              alwaysShowMask
                              maskChar={null}
                              className="ant-input width-100"
                              render={(ref, props) => (
                                  <Input  />
                              )}
                          />

                      )}
                  </FormItem>
              </Col>

              <Col xs={12} sm={12} md={8} lg={8} xl={8}>
                  <FormItem 
                  hasFeedback
                  validateStatus={this.state.IsFutureDate ? "error"  : undefined}
                      label={
                          <span>
                              Board Of Review Date&nbsp;
                          </span>
                      }
                  >
                      {getFieldDecorator('boardOfReviewDate', {
                          initialValue: eagleinfo && eagleinfo.eagleCertificateDate ? (eagleinfo.eagleBoardReviewDate != '' ? moment(eagleinfo.eagleBoardReviewDate).format('MM/DD/YYYY') : '') : '',
                          rules: [
                              {
                                required: true,
                                message: 'Enter Board Of Review Date'
                              },
                              { validator: this.validateNotFutureDate },
                              {
                                  pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                  message: `Please enter correct format MM/DD/YYYY Pattern`
                              }
                          ],
                      })(
                          // <Input placeholder="Date Of Birth" />

                          <InputMask
                              mask="99/99/9999"
                              placeholder='MM/DD/YYYY'
                              alwaysShowMask
                              maskChar={null}
                              className="ant-input width-100"
                              render={(ref, props) => (
                                  <Input  />
                              )}
                          />

                      )}
                  </FormItem>
              </Col>

              <Col xs={12} sm={12} md={8} lg={8} xl={8}>
                  <FormItem label={""}>
                        {getFieldDecorator('updateCurrentOrganization', {
                            initialValue: "",
                            rules: [{ required: false }],
                        })(
                            <Checkbox className="updateorganization-checkbox" onChange={ (e) => this.updateCurrentOrganization(e)}> Update Current Organization</Checkbox>
                        )}
                  </FormItem>
              </Col>
          </Row>

          <Row type="flex" className='btn-action' align="bottom" justify="space-between">
            <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                <FormItem>
                    <Button className="myprofile-cancel-btn" onClick={() => this.cancelActions()}>CANCEL</Button>
                </FormItem>
            </Col>

            <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                <FormItem>
                    <Button htmlType='submit' style={{margin: '0px', height: '56px'}} className="save-changes-button" type="primary"  disabled={this.isSaveDisabled()}>SAVE CHANGES</Button>
                </FormItem>
            </Col>
          </Row>
          </Form>
      </div>
    )
  }


  name = () => {
    if (!this.props.profileinfo) {
      return <Skeleton width={300} />
    }   
    else{
      const { profile } = this.props.profileinfo || {};
      const { firstName, middleName, lastName, nameSuffix, fullName } = profile || {};

      const formattedName =  `${firstName} ${middleName} ${lastName} ${nameSuffix ? nameSuffix : ''}`;
      return formattedName;
    }
      
  }
  checkIsDeceased = () => {
    if (!this.props.profileinfo) {
      return <Skeleton width={100} />
    }   
    else{
      const { profile } = this.props.profileinfo || {};
      const { isDeceased } = profile || '';

      return isDeceased ? " - Deceased" : '';
    }
  }

  render() {

    return (
      <div>
        {!this.props.PersonGuid && <LayoutHeader />}
        {!this.props.PersonGuid && <AdminNavigation />}
        
        <div className='repair-alumni'>
        
          <Row type="flex" justify="center">
            <Col xs={24} sm={24} md={24} lg={20} xl={20}>
              <Row>
                <Col span={24}> 
                  <div className='alumni-container'>
                    <div className='alumni-content'>
                     <div className='alumni-bg-banner'>
                        <Row type="flex" justify="space-between">
                        {this.props.location.pathname.includes() == "/record-repair" ? <span className='text pointer' onClick={() => history.push(`/${this.props.location.pathname}`)}><i className="fa fa-lg fa-long-arrow-left margin-right-5"></i> Back to Search Results</span> 
                          :
                          this.props.PersonGuid ? <span className='text pointer' onClick={() => this.handelChangeBackToSearch("false")}><i className="fa fa-lg fa-long-arrow-left margin-right-5"></i> Back to Search Results</span>
                          : <span className='text pointer' onClick={() => history.push('/' + this.state.returnto)}><i className="fa fa-lg fa-long-arrow-left margin-right-5"></i> Back to Search Results</span>}
                        </Row>
                        <Row type="flex" justify="center">
                          <div>
                            <span className='alumni-name' style={{ display: 'inline' }}>{this.name()}</span>
                            <span className='breadcrums'>{this.checkIsDeceased()}</span>
                          </div>
                        </Row>
                        <div align="left">
                          {this.rendereagleflag()}
                        </div>
                     </div>

                      
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className=''>
                  {this.renderEditView()}
              </Row>
            </Col>
          </Row>
          
        </div>
      </div>
    )
  }

}




function mapStateToProps(state) {
  return {
    loading: state.alumniinforeducer.loading,
    updating: state.adminRepairReducer.loading,
    error: state.columnlistreducer.error,
    preferencelistloading: state.quickpreferencelistreducer.loading,
    preferencelist: state.quickpreferencelistreducer.preferencelist,
    profileinfo: state.alumniinforeducer.profileinfo,
    councils: state.orgCouncilsReducer.councils,
    allstates: state.allstatesreducer.states,
    eagleinfo: state.alumnieagleinforeducer.eagleinfo,
    countries: state.countriesreducer.countries,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

const AddAlumniProfile = Form.create()(AddAlumniRecord);
export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(AddAlumniProfile);


// WEBPACK FOOTER //
// ./src/components/RecordRepair/AddAlumniRecord.js